import React from "react";
import { Link, useLocation } from "react-router-dom";

const Referensi = () => {
  const location = useLocation();


  const renderNavItem = (to, label, iconClass) => {
    const isActive = location.pathname === to;

    return (
      <li
        className={`kt-menu__item ${isActive ? "kt-menu__item--active" : ""}`}

        key={to}
      >
        <Link className="kt-menu__link" to={to}>
          <i className={`kt-menu__link-icon ${iconClass}`}></i>
          <span className="kt-menu__link-text">{label}</span>
        </Link>
      </li>
    );
  };

  return (
    <>
      {renderNavItem(
        "/referensi/komoditas",
        "Komoditas",
        "flaticon-interface-3"
      )}

      {renderNavItem(
        "/referensi/kontak",
        "Pemasok / Pemilik",
        "flaticon-customer"
      )}

      {renderNavItem(
        "/referensi/finance",
        "Referensi Finance",
        "flaticon-coins"
      )}
    </>
  );
};

export default Referensi;
